import {useMutation} from '@apollo/react-hooks';

import type {
    MeetingUndeleteInput,
    UndeleteManagedMeetingTemplate as UndeleteManagedMeetingTemplateMutation,
    UndeleteManagedMeetingTemplateVariables as UndeleteManagedMeetingTemplateMutationVariables,
    GetManagedMeetingsTemplates as GetManagedMeetingsTemplatesQuery,
} from 'nutshell-graphql-types';

import GET_MANAGED_MEETINGS_TEMPLATES from '../../../graphql/queries/get-managed-meetings-templates.graphql';

import UNDELETE_MANAGED_MEETING_TEMPLATE from '../mutations/undelete-managed-meeting-template.graphql';

export function useUndeleteManagedMeetingTemplate(
    archived: boolean
): (arg1: MeetingUndeleteInput) => Promise<any> {
    const [undeleteMeeting] = useMutation<
        UndeleteManagedMeetingTemplateMutation,
        UndeleteManagedMeetingTemplateMutationVariables
    >(UNDELETE_MANAGED_MEETING_TEMPLATE);

    return (undeleteInput: MeetingUndeleteInput) => {
        return undeleteMeeting({
            variables: {input: undeleteInput},

            update: (proxy, mutationResults) => {
                const cacheResult: GetManagedMeetingsTemplatesQuery | null | undefined =
                    proxy.readQuery({
                        query: GET_MANAGED_MEETINGS_TEMPLATES,
                        variables: {archived},
                    });

                const undeletedMeeting =
                    mutationResults &&
                    mutationResults.data &&
                    mutationResults.data.meetingUndelete &&
                    mutationResults.data.meetingUndelete.meeting;

                if (!undeletedMeeting) return;

                if (cacheResult) {
                    proxy.writeQuery({
                        query: GET_MANAGED_MEETINGS_TEMPLATES,
                        variables: {archived},
                        data: {
                            managedMeetings: cacheResult.managedMeetings.filter(
                                (meeting) => meeting.id !== undeletedMeeting.id
                            ),
                        },
                    });
                }
            },
        });
    };
}
